module.exports = __webpack_public_path__ + "static/img/areaA-31.229a31f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/文字バージョン/areaA-31.png
// module id = 984
// module chunks = 1